import mixitup from 'mixitup';

export default {
  init() {
    (function($) {
      $( document ).ready(function() {
          var mixer = mixitup('.mix-container');
          if(mixer) {
            console.log('mix');
          }
      });
    })(jQuery);
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/downloads.js